/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import template from './sw-cms-el-dvsn-form-builder.html.twig';
import './sw-cms-el-dvsn-form-builder.scss';

const { Component, Mixin } = Shopware;

Component.register('sw-cms-el-dvsn-form-builder', {
    template,

    mixins: [
        Mixin.getByName('cms-element')
    ],

    data() {
        return {
        }
    },

    computed: {
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.initElementConfig('dvsn-form-builder');
            this.initElementData('dvsn-form-builder');
        },
    }
});
